import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { utilitiesApi } from '@/api/utilities';

export function useReadings(leaseId: number | null) {
  return useQuery({
    queryKey: ['readings', leaseId],
    queryFn: () => utilitiesApi.list({ lease_id: leaseId as number }),
    enabled: leaseId !== null,
  });
}

export function useSubmitReading() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (form: FormData) => utilitiesApi.submit(form),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['readings'] });
    },
  });
}
